import { required, confirmed, length, email, min, max, numeric,integer } from 'vee-validate/dist/rules'
import { extend, localize } from 'vee-validate'
import ko from 'vee-validate/dist/locale/ko.json'

localize('ko', ko)

extend('required', {
  ...required,
  // message: 'This field is required1'
})

extend('email', {
  ...email,
  // message: 'This field must be a valid email'
})

extend('confirmed', {
  ...confirmed,
  // message: 'This field confirmation does not match'
})

extend('length', {
  ...length,
  // message: 'This field must have 2 options'
})

extend('numeric', {
  ...numeric,
  // message: 'This field must have 2 options'
})

extend('integer', {
  ...integer,
  // message: 'This field must have 2 options'
})

extend('min', {
  ...min,
  // message: 'This field must have 2 options'
})

extend('max', {
  ...max,
  // message: 'This field must have 2 options'
})

extend('id', (value) => {
  if (!/(^[a-zA-Z])/.test(value)) {
    return '아이디의 처음은 영문이여야 합니다.'
  }
  if (!/^[a-z0-9_-]{4,20}$/.test(value)) {
    return '아이디는 (영문소문자, 숫자, -,_)의 4~20자리로 입력해주세요.'
  }
  // if (!/^[a-zA-Z]{1}[a-zA-Z0-9_]{4,20}$/.test(value)) {
  //   return '첫글자는 영문이여야 하며, (영문소문자, 숫자, -,_)의 5~20자리로 입력해주세요.'
  // }

  return true
})
